module.exports = __webpack_public_path__ + "static/media/questionary-mob.23f477ca.svg";